import type { ILocale, IUser, IUserData, IUserGroup } from '@/entities';

export * from './user.types';

export class User implements IUser {
  id = '';
  avatarUrl = '';
  email = '';
  uiLanguage = '';
  contentLanguage = '';
  name = '';
  alias = '';
  title = '';
  timezone = '';
  roles: string[] = [];
  role = 'Learner';
  pointsEarned = 0;
  referralCode?: string;
  accountType = '';
  account = '';

  constructor(data: IUserData) {
    if (data) {
      this.id = data.id;
      this.avatarUrl = data.avatarUrl;
      this.email = data.email;
      this.pointsEarned = data.pointsEarned;
      if (data.uiLanguage) {
        this.uiLanguage = data.uiLanguage;
      }
      if (data.contentLanguage) {
        this.contentLanguage = data.contentLanguage;
      }
      this.name = data.name;
      this.alias = data.alias;
      this.title = '';
      this.timezone = '';
      this.roles = data.roles;
      if (data?.role) {
        this.role = data?.role;
      }
      this.account = data?.account;
      this.accountType = data?.accountType;
    }
  }

  get rank() {
    if (this.pointsEarned < 2000) {
      return 'Beginner';
    }
    if (this.pointsEarned < 4000) {
      return 'Bronze';
    }
    if (this.pointsEarned < 6000) {
      return 'Silver';
    }
    if (this.pointsEarned < 8000) {
      return 'Gold';
    }
    return 'Platinum';
  }
}

export class UserGroup implements IUserGroup {
  id = '';
  dateCreated = '';
  description = '';
  name = '';
  readOnly = false;
  state = '';
  userCount = 0;

  constructor(data: any) {
    if (data) {
      this.id = data.id;
      this.dateCreated = data.dateCreated;
      this.description = data.description;
      this.name = data.name;
      this.readOnly = data.readOnly;
      this.state = data.state;
      this.userCount = data.userCount;
    }
  }
}

export class Locale implements ILocale {
  id = 0;
  locale = '';
  name = '';

  constructor(data: any) {
    if (data) {
      this.id = data.id;
      this.locale = data.locale;
      this.name = data.name;
    }
  }
}
